import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  addArray as addFollowedCardArray,
  removeAll as removeAllFollowedCards
} from '../redux/followedCards'

export default function * fetchFollowedCards (action) {
  yield put([
    removeAllFollowedCards(),
    setLoadStatus({
      isLoading: true,
      isLoaded: false
    })
  ])

  try {
    const { Boards } = yield call(apiGetData, 'CardsIFollow')

    let array = []

    Boards.forEach(Board => {
      Board.Cards.forEach(Card => {
        array.push({
          id: Card.Id,
          name: Card.Name,
          isArchived: Card.IsArchived,
          boardId: Board.Id,
          boardName: Board.Name
        })
      })
    })

    yield put([
      addFollowedCardArray(array),
      setLoadStatus({
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))

    throw error
  }
}
